import { api } from "./apiClient";

const GEOLOCATION_OPTIONS = {
  enableHighAccuracy: false,
  timeout: 10000,
  // "Near me" must reflect the device's current position. A value of zero
  // prevents the browser from satisfying the request from its position cache.
  maximumAge: 0,
};

export function getCurrentLocation(
  geolocation = typeof navigator !== "undefined" ? navigator.geolocation : undefined
) {
  if (!geolocation?.getCurrentPosition) {
    return Promise.reject(new Error("Geolocation is unavailable"));
  }

  return new Promise((resolve, reject) => {
    geolocation.getCurrentPosition(
      ({ coords }) => resolve({
        latitude: coords.latitude,
        longitude: coords.longitude,
        accuracy: coords.accuracy,
      }),
      reject,
      GEOLOCATION_OPTIONS
    );
  });
}

export function cityNamesFromLocationData(payload) {
  const records = Array.isArray(payload?.data) ? payload.data : [];
  return records
    .filter((city) => city && typeof city.id === "string" && typeof city.name === "string")
    .map((city) => ({
      id: city.id,
      name: city.name.trim(),
      countryCode: city.countryCode,
      regionCode: city.regionCode,
      timeZone: city.timeZone,
      displayName: city.displayName || city.name.trim(),
      latitude: city.latitude,
      longitude: city.longitude,
      source: city.source,
    }))
    .filter((city) => city.name);
}

let citiesPromise;

export function getLocationCities(options) {
  citiesPromise ||= api.get("/locations/cities", options).then(cityNamesFromLocationData);
  return citiesPromise;
}

const locationSearches = new Map();

export function searchLocationCities(query, options) {
  const normalizedQuery = String(query || "").trim();
  if (normalizedQuery.length < 2) return Promise.resolve([]);
  if (!locationSearches.has(normalizedQuery)) {
    locationSearches.set(
      normalizedQuery,
      api.get("/locations/cities", { ...options, query: { q: normalizedQuery } })
        .then(cityNamesFromLocationData)
        .catch((error) => {
          locationSearches.delete(normalizedQuery);
          throw error;
        })
    );
  }
  return locationSearches.get(normalizedQuery);
}
